// extracted by mini-css-extract-plugin
export default {"reviewContainer":"annualReview_reviewContainer__pY6MG"};